// Finance build (Workstream E) — TanStack Query hook for the cross-loan Loan
// Payments ledger. Read-only; no mutations (this surface only displays the v3
// payment ledger).

import { useQuery } from "@tanstack/react-query";
import { loanPaymentsApi } from "@/api/portfolioAdmin/loanPaymentsApi";
import { loanPaymentsKeys } from "./loanPaymentsKeys";

export function useLoanPaymentsLedger(params?: {
  loanId?: string;
  status?: string;
  from?: string;
  to?: string;
}) {
  return useQuery({
    queryKey: loanPaymentsKeys.ledger(params),
    queryFn: () => loanPaymentsApi.ledger(params),
  });
}
